import { useEffect } from "react";

import {
  IWidgetType,
  useDashboardApi
} from "../api/dashboard.api";

export default () => {
  const [ getWidgetTypesRes, getWidgetTypesReq ] = useDashboardApi("GET_WIDGET_TYPES");

  useEffect(() => {
    getWidgetTypesReq(null);
  }, [ getWidgetTypesReq ]);

  return (getWidgetTypesRes.data || []) as IWidgetType[];
};
